import { useToastStore } from "../hooks/useToast";
import { ToastItem } from "./Toast";

export const ToastContainer = () => {
  const toasts = useToastStore();

  return (
    <div role="status" aria-label="Alerts" class="pointer-events-none fixed top-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 w-full max-w-sm px-4">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
};
